const checkIsMac = () => {
  const nav = navigator as Navigator & { userAgentData?: { platform?: string } };
  if (nav.userAgentData?.platform) {
    return /Mac|macOS/i.test(nav.userAgentData.platform);
  }
  return /Mac|Macintosh|macOS/i.test(navigator.userAgent);
};

export default checkIsMac;
